var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.89 17.2401C11.7584 17.2408 11.6279 17.2156 11.5061 17.1658C11.3843 17.1161 11.2735 17.0427 11.18 16.9501L5.18001 10.9501C5.08629 10.8571 5.01189 10.7465 4.96112 10.6246C4.91035 10.5028 4.88422 10.3721 4.88422 10.2401C4.88422 10.108 4.91035 9.97733 4.96112 9.85547C5.01189 9.73361 5.08629 9.62301 5.18001 9.53005C5.36738 9.3438 5.62083 9.23926 5.88502 9.23926C6.1492 9.23926 6.40265 9.3438 6.59001 9.53005L11.89 14.8301L17.18 9.53005C17.3674 9.3438 17.6208 9.23926 17.885 9.23926C18.1492 9.23926 18.4027 9.3438 18.59 9.53005C18.6837 9.62301 18.7581 9.73361 18.8089 9.85547C18.8597 9.97733 18.8858 10.108 18.8858 10.2401C18.8858 10.3721 18.8597 10.5028 18.8089 10.6246C18.7581 10.7465 18.6837 10.8571 18.59 10.9501L12.59 16.9501C12.4038 17.1348 12.1524 17.2389 11.89 17.2401Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default __webpack_public_path__ + "static/media/IconChevron-Down.f1f0649d439e94d28b7f36f5c3a3b880.svg";
export { ForwardRef as ReactComponent };